// extracted by mini-css-extract-plugin
export default {"show-more":"ums6HS9f6Cj93TRC5VnAwQ=="};